import { NavLink, useLocation } from "react-router-dom";
import { Sun, Compass, Map, TrendingUp, Menu as MenuIcon, Plus } from "lucide-react";
import { useState } from "react";
import AddToJourneySheet from "@/components/AddToJourneySheet";
import { useLang } from "@/context/LanguageContext";
import PaywallGuard from "@/components/PaywallGuard";

export default function AppLayout({ children }) {
  const location = useLocation();
  const { t } = useLang();
  const [fabOpen, setFabOpen] = useState(false);
  const showFab = !location.pathname.endsWith("/menu");

  const tabs = [
    { to: "/app/today", label: t("nav.today"), icon: Sun, testid: "tab-today" },
    { to: "/app/mission", label: t("nav.mission"), icon: Compass, testid: "tab-mission" },
    { to: "/app/journey", label: t("nav.journey"), icon: Map, testid: "tab-journey" },
    { to: "/app/progress", label: t("nav.progress"), icon: TrendingUp, testid: "tab-progress" },
    { to: "/app/menu", label: t("nav.menu"), icon: MenuIcon, testid: "tab-menu" },
  ];

  return (
    <div className="min-h-screen pb-24" style={{ backgroundColor: "var(--vedari-cream)", color: "var(--vedari-ink)" }}>
      <main className="max-w-md mx-auto px-6 pt-6">
        <PaywallGuard>{children}</PaywallGuard>
      </main>

      {showFab && (
        <button
          onClick={() => setFabOpen(true)}
          data-testid="add-to-journey-fab"
          aria-label="Add to journey"
          className="fixed bottom-24 right-5 w-14 h-14 rounded-full shadow-warm-lg flex items-center justify-center transition-transform active:scale-95 z-30"
          style={{ backgroundColor: "var(--vedari-gold)", color: "var(--vedari-cream)" }}
        >
          <Plus size={24} strokeWidth={1.75} />
        </button>
      )}

      <AddToJourneySheet open={fabOpen} onClose={() => setFabOpen(false)} />

      <nav
        className="fixed bottom-0 left-0 right-0 z-40 border-t"
        style={{ backgroundColor: "var(--vedari-surface)", borderColor: "var(--vedari-divider)", height: "64px" }}
        data-testid="bottom-nav"
      >
        <div className="max-w-md mx-auto h-full grid grid-cols-5">
          {tabs.map((t) => (
            <NavLink
              key={t.to}
              to={t.to}
              data-testid={t.testid}
              aria-label={t.label}
              className="flex flex-col items-center justify-center gap-1 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-1"
              style={({ isActive }) => ({
                color: isActive ? "var(--vedari-gold)" : "var(--vedari-ink-soft)",
              })}
            >
              <t.icon size={22} strokeWidth={1.5} aria-hidden="true" />
              <span className="text-[11px] font-medium tracking-wide">{t.label}</span>
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}
